<div class="mbway-payment d-flex justify-content-center">
    <i class="btn-close icon-edponline-Bop-071" (click)="closeModal()"  aria-hidden="true"></i>
    <div class="open-modal">
        <div class="left-side">
            <span class="title" [innerHTML]="'pt.edp.edponline.payment.modal.error.feedback.title' | translate"></span>
            <span class="description" [innerHTML]="'pt.edp.edponline.payment.modal.error.feedback.giveUsFeedback' | translate"></span>
        </div>
        <div class="right-side edp-scroll-disabled">        
            <ng-container *ngFor="let feedback of arrayPaymentFeedback">
                <div class="bank-card cursor-pointer" (click)="feedbackChoice(feedback)">
                    <span class="text">{{ feedback.name | translate }}</span>
                </div>
            </ng-container>
            <form [formGroup]="feedbackForm" class="edp-form d-flex w-100" *ngIf="otherFeedbackSelected">
                <div class="form input-container pt-4 fluid specific-feedback-input">
                    <div class="d-inline-flex w-100 mb-3">
                        <label class="specific-feedback-label">{{ 'pt.edp.edponline.payment.modal.error.feedback.other.title' | translate }}:</label>
                    </div>
                    <input type="text" minlength="3" maxlength="70" class="form-control" formControlName="otherFeedback"
                        placeholder="{{ 'pt.edp.edponline.payment.modal.error.feedback.other.example' | translate }}">
                </div>
                <div class="specific-feedback-submit">
                    <button
                        class="btn btn-primary w-100 px-5 align-bottom"
                        [disabled]="feedbackForm.controls.otherFeedback.invalid"
                        [ngClass]="{ 'disabled': feedbackForm.controls.otherFeedback.invalid }"
                        (click)="feedbackSubmit()">
                        {{ 'pt.edp.edponline.payment.modal.error.feedback.other.send' | translate | edpCapitalize }}
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>